// removed by extract-text-webpack-plugin
module.exports = {"hoveredItem":"style__hoveredItem___3H2d4","dragging":"style__dragging___3GW82"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ClubCMS/DragItems/DraggableItem/style.scss
// module id = 2216
// module chunks = 0